if (!window.Eurus.loadedScript.has('flexible-area.js')) {
    window.Eurus.loadedScript.add('flexible-area.js');
  
    requestAnimationFrame(() => {
      document.addEventListener('alpine:init', () => {
        Alpine.data('xFlexibleArea', () => ({
          initArea(el) {
            this.adjustFlexWidths(el);

            let resizeTimer;
            window.addEventListener('resize', () => {
              clearTimeout(resizeTimer);
              resizeTimer = setTimeout(() => {
                this.adjustFlexWidths(el);
              }, 50);
            });
          },

          adjustFlexWidths(container) {
            const isMobile = window.innerWidth <= 767;
            const distributeRow = container.dataset.distributeRow === 'true';

            const items = Array.from(container.children).map(el => {
              const itemBlock = el.querySelector('.item-block');
              const itemWidth = parseFloat(isMobile ? itemBlock.dataset.widthMobile : itemBlock.dataset.width) || 0;
              return { el, itemWidth };
            });

            const style = getComputedStyle(container);
            const computedColumnGap = parseFloat(style.columnGap || style.gap || 0);
            const containerWidth = container.clientWidth;

            const rows = [];
            let currentRow = [];
            let currentTotal = 0;

            items.forEach(({ el, itemWidth }) => {
              if (currentRow.length && currentTotal + itemWidth > 100) {
                rows.push(currentRow);
                currentRow = [{ el, itemWidth }];
                currentTotal = itemWidth;
              } else {
                currentRow.push({ el, itemWidth });
                currentTotal += itemWidth;
              }
            });

            if (currentRow.length) {
              rows.push(currentRow);
            }

            container.style.justifyContent = '';
            container.style.columnGap = '';

            rows.forEach(row => {
              this.applyRowWidths(row, computedColumnGap, containerWidth, distributeRow);
            });
          },

          applyRowWidths(row, gap, containerWidth, distributeRow = false) {
            if (!row.length) return;

            const totalGap = gap * (row.length - 1);
            const gapWidth = (totalGap / containerWidth) * 100;
            const usableWidth = Math.max(0, 100 - gapWidth);
            const rowWidth = row.reduce((total, { itemWidth }) => total + itemWidth, 0);
            const widthBase = distributeRow && rowWidth > 0 ? rowWidth : 100;

            row.forEach(({ el, itemWidth }) => {
              const flexWidth = usableWidth * (itemWidth / widthBase);
              el.style.flex = `0 0 ${flexWidth}%`;
              el.style.width = distributeRow ? `${flexWidth}%` : '';
              el.style.maxWidth = distributeRow ? `${flexWidth}%` : '';
            });
          }
        }));
      });
    });
  }
